var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgActionSend(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.75036 10.0003H4.16702M4.09648 10.2432L2.15071 16.0555C1.99785 16.5121 1.92142 16.7404 1.97627 16.881C2.0239 17.0031 2.1262 17.0957 2.25244 17.1309C2.3978 17.1715 2.61736 17.0727 3.05647 16.8751L16.9827 10.6083C17.4113 10.4154 17.6256 10.319 17.6918 10.185C17.7494 10.0686 17.7494 9.93203 17.6918 9.81564C17.6256 9.68168 17.4113 9.58524 16.9827 9.39237L3.05161 3.12342C2.61383 2.92641 2.39493 2.82791 2.24971 2.86832C2.1236 2.90341 2.0213 2.99573 1.97351 3.1176C1.91847 3.25793 1.99408 3.48574 2.14531 3.94137L4.09702 9.82159C4.12299 9.89984 4.13598 9.93897 4.14111 9.97899C4.14565 10.0145 4.14561 10.0504 4.14097 10.0859C4.13574 10.1259 4.12265 10.165 4.09648 10.2432Z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActionSend);
export default __webpack_public_path__ + "static/media/action-send.2f3ff7a34aeed6114edcd0e3b6d22e66.svg";
export { ForwardRef as ReactComponent };